// extracted by mini-css-extract-plugin
export default {"button":"Button_button__xOnxM","buttona":"Button_buttona__HZoHo","white":"Button_white__bSrQZ","addStyle":"Button_addStyle__XiM2J"};